var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolioIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1219.98,
    y1: 107.02,
    x2: -1040,
    y2: 107.02,
    gradientTransform: "matrix(1, 0, 0, -1, 1255, 229)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "blue"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e600ff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconsForMenu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.65,63.82H163.72a1.37,1.37,0,0,1-1.37-1.38V54.56a5.49,5.49,0,0,0,0-.58c-.21-1.91-1.71-11-11.3-11H99.84s-11.37.31-11.37,11.35v7.5a2,2,0,0,1-2,2l-46.13,0A5.36,5.36,0,0,0,35,69.21V187.92a13,13,0,0,0,13,13H202.58A12.43,12.43,0,0,0,215,188.53V69.17A5.34,5.34,0,0,0,209.65,63.82ZM98.28,55.47a5.06,5.06,0,0,1,5.06-5.06H147a5.28,5.28,0,0,1,5.3,5.26v8.15H98.28ZM47.73,75H204.06l-16.83,48.75a4,4,0,0,1-3.79,2.7h-32.5V121a3.68,3.68,0,0,0-3.68-3.68H102.7a3.23,3.23,0,0,0-3.22,3.23v6H71.79a10,10,0,0,1-9.46-6.85Zm93.8,52.65v9.81H109.29v-9.81Zm64.06,58.06a5.2,5.2,0,0,1-5.2,5.21H49.06l-2.7-.86c-.21,0-1.26-.78-1.36-3.59-.67-17.52.47-80.82.47-80.82l9,21.73a16.62,16.62,0,0,0,15.37,10.28H98.39a.69.69,0,0,1,.69.7v5.91a3.61,3.61,0,0,0,3.61,3.6h44.44a3.61,3.61,0,0,0,3.61-3.6v-6.12a.68.68,0,0,1,.68-.69H184a13.21,13.21,0,0,0,12.53-9l9-27v84.26Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioIcon);
export default __webpack_public_path__ + "static/media/portfolioIcon.b6a03d5109bdced5138ace17e9034224.svg";
export { ForwardRef as ReactComponent };